import Segment from "./Segment";
import NextLesson from "./NextLesson";
import LessonSection from "./LessonSection";

export default class Lesson {
  id: string;
  title: string;  //e.g. 5-Finger Position
  difficulty: number;
  segments: Segment[];
  nextLesson?: NextLesson;
  subTitle: string;
  coverArtUrl: string;
  isFirstLessonOfSection: boolean;
  isLastLessonOfSection: boolean;
  section?: LessonSection;
  nextSection?: LessonSection;

  constructor({ id, title, segments, difficulty, nextLesson, subTitle, coverArtUrl, isFirstLessonOfSection,
    isLastLessonOfSection, section, nextSection}: Lesson) {

    Object.assign(this, { id, title, segments, difficulty, nextLesson, subTitle, coverArtUrl,
      isFirstLessonOfSection, isLastLessonOfSection, section, nextSection });
  }
}